// TUT-491 — a caixa de entrada única: a lista que junta atendimento, chat e
// portal, as conversas fixadas (no servidor) e as respostas prontas.
import { criarClienteDeChatDemo } from "../chat-demo";
import { demoApi } from "../demo-data";
import {
  caixaDaDemonstracao,
  desafixarConversaDemo,
  fixarConversaDemo,
  removerRespostaProntaDemo,
  respostasProntasDemo,
  salvarRespostaProntaDemo,
} from "../demo/conversas";
import { demoSession } from "../demo/sessao";
import type { CaixaDeConversas, RespostaPronta, RespostaProntaInput } from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

/**
 * O modo demonstração cai em `UNAVAILABLE` como o servidor: a Inbox que falha
 * não derruba a caixa. `?__tutelae_atendimento=fora` na URL simula a Inbox fora
 * do ar (a e2e usa).
 */
function caixaDemo(paginaExterna: number): Promise<CaixaDeConversas> {
  return caixaDaDemonstracao({
    atende: demoSession.permissions.includes("atendimento.atender"),
    fora: new URLSearchParams(window.location.search).get("__tutelae_atendimento") === "fora",
    inbox: (pagina) => demoApi.inboxConversations(pagina),
    chat: () => criarClienteDeChatDemo(false).listConversations(),
    meuId: demoSession.user.id,
    pagina: paginaExterna,
  });
}

export const apiDasConversas = {
  caixaDeConversas(paginaExterna = 1): Promise<CaixaDeConversas> {
    if (useDemoApi) return caixaDemo(paginaExterna);
    return request<CaixaDeConversas>(`/conversas${paginaExterna > 1 ? `?paginaExterna=${paginaExterna}` : ""}`);
  },
  fixarConversa(conversaId: string): Promise<{ fixadas: string[] }> {
    if (useDemoApi) return fixarConversaDemo(conversaId);
    return request(`/conversas/fixadas/${encodeURIComponent(conversaId)}`, { method: "PUT" });
  },
  desafixarConversa(conversaId: string): Promise<{ fixadas: string[] }> {
    if (useDemoApi) return desafixarConversaDemo(conversaId);
    return request(`/conversas/fixadas/${encodeURIComponent(conversaId)}`, { method: "DELETE" });
  },
  respostasProntas(): Promise<{ itens: RespostaPronta[] }> {
    if (useDemoApi) return respostasProntasDemo();
    return request("/respostas-prontas");
  },
  criarRespostaPronta(input: RespostaProntaInput): Promise<RespostaPronta> {
    if (useDemoApi) return salvarRespostaProntaDemo(input);
    return request("/respostas-prontas", { method: "POST", body: JSON.stringify(input) });
  },
  alterarRespostaPronta(id: string, input: RespostaProntaInput): Promise<RespostaPronta> {
    if (useDemoApi) return salvarRespostaProntaDemo(input, id);
    return request(`/respostas-prontas/${id}`, { method: "PATCH", body: JSON.stringify(input) });
  },
  removerRespostaPronta(id: string): Promise<void> {
    if (useDemoApi) return removerRespostaProntaDemo(id);
    return request(`/respostas-prontas/${id}`, { method: "DELETE" });
  },
};
